import { IonAlert, IonAvatar, IonBadge, IonButton, IonChip, IonCol, IonGrid, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonText, IonToast, IonToolbar, useIonAlert, IonModal, IonInput, IonContent, IonHeader, IonTitle, IonCheckbox } from '@ionic/react';
import { bookmark, bookmarkOutline, camera, car, card, checkbox, checkmarkCircle, checkmarkCircleOutline, checkmarkDoneCircle, documentText, ellipse, ellipsisHorizontalOutline, flag, flagOutline, handRight, megaphone, pause, pauseCircle, pencil, person, playCircle, power, pulseOutline, repeatOutline, sync } from 'ionicons/icons';
import React, { useCallback } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { urlBase, operacaoLiberarOperacao, operacaoAtualizarSemaforo, operacaoRegistrarAnotacao, operacaoChamarMotorista, encerrarOperacao, operacaoAlterarStatusOperacao, operacaoAlterarStatusEncerramento, operacaoAlterarTipoCarga } from '../../../../../Utils/Services';
//import PropTypes from 'prop-types'
import './OperacoesList.css';

const MOTIVOS_DEVOLUCAO = [
    'Item sem cadastro',
    'Tributação',
    'Nota Duplicada',
    'Custo',
    'Quantidade',
    'Pedido atrasado',
    'Vencimento próximo',
    'Improprio para consumo',
    'NF-e cancelada',
    'Sem pedido'
];

class OperacoesList extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            loading: true,
            ret: { Items: [] },
            filtro: "",
            lojas: "",
            lastEvaluatedKey: null,
            showAlert: false,
            indice: null,
            showModalDevolucao: false,
            notasDevolucao: {},
            statusEncerramentoTemp: null
        };
        this.loadMoreItems = this.loadMoreItems.bind(this);
        this.changeSemaforo = this.changeSemaforo.bind(this);
        this.changeLiberacao = this.changeLiberacao.bind(this);
        this.changeStatusOperacao = this.changeStatusOperacao.bind(this);
        this.changeStatusEncerramento = this.changeStatusEncerramento.bind(this);
        this.changeTipoCarga = this.changeTipoCarga.bind(this);
        this.registrarAnotacao = this.registrarAnotacao.bind(this);
        this.registrarChamada = this.registrarChamada.bind(this);
        this.registrarEncerramento = this.registrarEncerramento.bind(this);
    }

    getNumeroNota(nota: any) {
        if (!nota?.notaFiscal) {
            return 'N/A';
        }

        return nota.notaFiscal.substr(25, 9);
    }

    async changeSemaforo(indice: any, semaforo: any) {
        let obj = [...this.state.ret.Items];
        obj[indice].atualizandoSemaforo = true;
        this.setState((state: any) => ({ ...state, [state.ret.Items]: [...obj] }));

        let objBefore = [...this.state.ret.Items];

        let result = await this.updateSemaforo(obj[indice].pk, semaforo);
        if (result) {
            obj[indice].atualizandoSemaforo = false;
            obj[indice].semaforo = semaforo;
            setTimeout(() => { this.setState((state: any) => ({ ...state, [state.ret.Items]: [...obj] })); }, 500);
        } else {
            objBefore[indice].atualizandoSemaforo = false;
            setTimeout(() => this.setState((state: any) => ({ ...state, [state.ret.Items]: [...objBefore] })), 500);
        }
    }

    async changeLiberacao(indice: any, liberado: any) {
        let obj = [...this.state.ret.Items];
        let anotacoes = obj[indice].anotacoes;
        obj[indice].atualizandoLiberacao = true;
        obj[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: 'Incluindo...' }]
        this.setState((state: any) => ({ ...state, [state.ret.Items]: [...obj] }));

        let objBefore = [...this.state.ret.Items];

        let result = await this.updateLiberacaoService(obj[indice].pk, liberado);
        if (result) {
            obj[indice].atualizandoLiberacao = false;
            obj[indice].liberado = liberado;
            obj[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: liberado == true ? "Operação liberada" : "Operação em liberação", pessoa: 'você' }];
            setTimeout(() => { this.setState((state: any) => ({ ...state, [state.ret.Items]: [...obj] })); }, 500);
        } else {
            objBefore[indice].atualizandoLiberacao = false;
            objBefore[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: 'Erro na inserção. Tente novamente.', cor: 'var(--ion-color-danger)' }];
            setTimeout(() => this.setState((state: any) => ({ ...state, [state.ret.Items]: [...objBefore] })), 500);
        }
    }

    async changeStatusOperacao(indice: any, statusOperacao: any) {
        if (statusOperacao == "Pré-liberado") {
            setTimeout(() => this.setState((state: any) => ({ ...state })), 500);
            return;
        }
        else if (this.state.ret.Items[indice].statusOperacao == statusOperacao) {
            return;
        }
        else {
            let obj = [...this.state.ret.Items];
            let anotacoes = obj[indice].anotacoes;
            obj[indice].atualizandoStatusOperacao = true;
            obj[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: 'Incluindo...', tipo: 'Status' }]
            this.setState((state: any) => ({ ...state, [state.ret.Items]: [...obj] }));

            let objBefore = [...this.state.ret.Items];

            let result = await this.updateStatusOperacaoService(obj[indice].pk, statusOperacao);
            if (result) {
                obj[indice].atualizandoStatusOperacao = false;
                obj[indice].statusOperacao = statusOperacao;
                obj[indice].liberado = statusOperacao == 'Liberado' ? true : false;
                obj[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: statusOperacao, pessoa: 'você', tipo: 'Status' }];
                setTimeout(() => { this.setState((state: any) => ({ ...state, [state.ret.Items]: [...obj] })); }, 500);
            } else {
                objBefore[indice].atualizandoStatusOperacao = false;
                objBefore[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: 'Erro na inserção de status. Tente novamente.', cor: 'var(--ion-color-danger)', tipo: 'Status' }];
                setTimeout(() => this.setState((state: any) => ({ ...state, [state.ret.Items]: [...objBefore] })), 500);
            }
        }
    }

    async changeStatusEncerramento(indice: any, statusEncerramento: any) {
        let obj = [...this.state.ret.Items];
        let anotacoes = obj[indice].anotacoes;
        obj[indice].atualizandoStatusEncerramento = true;
        obj[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: 'Incluindo...' }]
        this.setState((state: any) => ({ ...state, [state.ret.Items]: [...obj] }));

        let objBefore = [...this.state.ret.Items];

        let result = await this.updateStatusEncerramentoService(obj[indice].pk, statusEncerramento);
        if (result) {
            obj[indice].atualizandoStatusEncerramento = false;
            obj[indice].statusEncerramento = statusEncerramento;
            obj[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: 'Classificação encerramento: ' + statusEncerramento, pessoa: 'você' }];
            setTimeout(() => { this.setState((state: any) => ({ ...state, [state.ret.Items]: [...obj] })); }, 500);
        } else {
            objBefore[indice].atualizandoStatusEncerramento = false;
            objBefore[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: 'Erro na inserção de status. Tente novamente.', cor: 'var(--ion-color-danger)' }];
            setTimeout(() => this.setState((state: any) => ({ ...state, [state.ret.Items]: [...objBefore] })), 500);
        }
    }

    async changeTipoCarga(indice: any, tipoCarga: any) {
        if (this.state.ret.Items[indice].tipoCarga == tipoCarga) {
            return;
        }

        let obj = [...this.state.ret.Items];
        obj[indice].atualizandoTipoCarga = true;
        this.setState((state: any) => ({ ...state, [state.ret.Items]: [...obj] }));

        let objBefore = [...this.state.ret.Items];

        let result = await this.updateTipoCargaService(obj[indice].pk, tipoCarga);
        if (result) {
            obj[indice].atualizandoTipoCarga = false;
            obj[indice].tipoCarga = tipoCarga;
            setTimeout(() => { this.setState((state: any) => ({ ...state, [state.ret.Items]: [...obj] })); }, 500);
        } else {
            objBefore[indice].atualizandoTipoCarga = false;
            setTimeout(() => this.setState((state: any) => ({ ...state, [state.ret.Items]: [...objBefore] })), 500);
        }
    }

    async registrarAnotacao(indice: any) {
        this.setState({ indice: indice, showAlertAnotacao: true });
    }

    async registrarChamada(indice: any) {
        this.setState({ indice: indice, showAlertChamada: true });
    }

    async registrarEncerramento(indice: any) {
        this.setState({ indice: indice, showAlertEncerramento: true });
    }

    async salvarDevolucaoNota(notaFiscal: string) {
        const notaData = this.state.notasDevolucao[notaFiscal];

        // Validar campos obrigatórios se marcada como devolvida
        if (notaData.devolvida) {
            if (!notaData.motivo || notaData.motivo.trim() === '') {
                alert('Motivo é obrigatório');
                return;
            }
            if (!notaData.valor || notaData.valor.toString().trim() === '') {
                alert('Valor é obrigatório');
                return;
            }
            if (!notaData.vencimento || notaData.vencimento.trim() === '') {
                alert('Vencimento é obrigatório');
                return;
            }
        }

        // Chamar API para salvar os dados da devolução
        const indice = this.state.indice;
        const operacaoPk = this.state.ret.Items[indice].pk;

        const devolucaoData = {
            notaFiscal: notaFiscal,
            motivo: notaData.motivo,
            valor: notaData.valor,
            vencimento: notaData.vencimento
        };

        try {
            // Aqui você chamará sua API de devolução
            const response = await fetch(`${urlBase.url}/operacoes/registrar-devolucao/${operacaoPk}`, {
                method: 'POST',
                headers: [
                    ["token", localStorage.getItem("token") || ""]
                ],
                body: JSON.stringify(devolucaoData),
                credentials: 'include'
            });

            const result = await response.json();
            if (response.status === 200) {
                alert('Devolução salva com sucesso!');
            } else {
                alert('Erro ao salvar devolução: ' + (result.message || ''));
            }
        } catch (error) {
            console.error('Erro ao salvar devolução:', error);
            alert('Erro ao salvar devolução');
        }
    }

    async finalizarDevolvucaoEEncerrar() {
        // Verificar se há notas marcadas como devolvidas
        const todasAsNotas = Object.values(this.state.notasDevolucao) as any[];
        const notasDevolvidas = todasAsNotas.filter(nota => nota.devolvida);

        if (notasDevolvidas.length === 0) {
            alert('Marque pelo menos uma nota como devolvida');
            return;
        }

        // Encerrar a operação
        const indice = this.state.indice;
        let items = [...this.state.ret.Items];
        items[indice].divEncerrando = true;
        this.setState((state: any) => ({
            ...state,
            [state.ret.Items]: [...items],
            showModalDevolucao: false
        }));

        let result = await this.putEncerramento(items[indice].pk, this.state.statusEncerramentoTemp, notasDevolvidas);
        if (result) {
            setTimeout(() => {
                items[indice].divEncerrado = true;
                this.setState((state: any) => ({
                    ...state,
                    [state.ret.Items]: [...items],
                    showModalDevolucao: false
                }));
            }, 1000);
        } else {
            items[indice].divEncerrando = false;
            this.setState((state: any) => ({
                ...state,
                [state.ret.Items]: [...items],
                showModalDevolucao: false
            }));
        }
    }

    render() {
        const { loading, ret } = this.state;
        //console.log("ret", ret);
        return loading ? <div style={{ width: '100%', textAlign: 'center' }}><br></br>Carregando...</div> : (
            <>
                <OperacoesCards lojasCores={this.props.lojasCores} items={ret || []} router={this.props.router} loadMoreItems={this.loadMoreItems} changeSemaforo={this.changeSemaforo} usaLiberacao={this.props.usaLiberacao} changeLiberacao={this.changeLiberacao} registrarAnotacao={this.registrarAnotacao} registrarChamada={this.registrarChamada} registrarEncerramento={this.registrarEncerramento} pesquisa={this.props.pesquisa} chipStatusOperacaoFilter={this.props.chipStatusOperacaoFilter} chipCargaFilter={this.props.chipCargaFilter} chipTipoOperacaoFilter={this.props.chipTipoOperacaoFilter} chipValidacaoFilter={this.props.chipValidacaoFilter} changeStatusOperacao={this.changeStatusOperacao} changeStatusEncerramento={this.changeStatusEncerramento} changeTipoCarga={this.changeTipoCarga} clienteUtilizaLeituraCega={this.props.clienteUtilizaLeituraCega} />
                <IonAlert
                    isOpen={this.state.showAlertAnotacao}
                    onDidDismiss={() => this.setState((state: any) => ({ ...state, showAlertAnotacao: false }))}
                    cssClass="my-custom-class"
                    header={'Registrar anotação na operação'}
                    message={'Digite a anotação abaixo'}
                    backdropDismiss={false}
                    inputs={[
                        {
                            name: 'mensagem',
                            type: 'textarea',
                            id: 'name2-id',
                            placeholder: 'Digite aqui a anotação',
                        }]}
                    buttons={['Cancel', {
                        text: 'Incluir', handler: async (d) => {
                            if (!d.mensagem || d.mensagem.trim() == "") {
                                return null;
                            }

                            const indice = this.state.indice;
                            let items = [...this.state.ret.Items];
                            let anotacoes = items[indice].anotacoes;
                            items[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: 'Incluindo...' }]
                            this.setState((state: any) => ({ ...state, [state.ret.Items]: [...items], showAlertAnotacao: false }));

                            let result = await this.postAnotacao(items[indice].pk, d.mensagem);
                            if (result) {
                                //items[indice].anotacoes = [...items[indice].anotacoes, { data: new Date().toISOString(), anotacao: d.mensagem }];
                                setTimeout(() => {
                                    items[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: d.mensagem }];
                                    this.setState((state: any) => ({ ...state, [state.ret.Items]: [...items], showAlertAnotacao: false }));
                                }, 1000);
                            }
                            else {
                                items[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: 'Erro na inserção...', cor: 'var(--ion-color-danger)' }];
                                this.setState((state: any) => ({ ...state, [state.ret.Items]: [...items], showAlertAnotacao: false }));
                                setTimeout(() => {
                                    items[indice].anotacoes = [...anotacoes];
                                    this.setState((state: any) => ({ ...state, [state.ret.Items]: [...items], showAlertAnotacao: false }));
                                }, 5000);
                            }
                        }
                    }]}
                />
                <IonAlert
                    isOpen={this.state.showAlertChamada}
                    onDidDismiss={() => this.setState((state: any) => ({ ...state, showAlertChamada: false }))}
                    cssClass="my-custom-class"
                    header={'Enviar mensagem ao motorista'}
                    message={'Digite a mensagem abaixo'}
                    backdropDismiss={false}
                    inputs={[
                        {
                            name: 'mensagem',
                            type: 'textarea',
                            id: 'name2-id',
                            value: 'Hora de descarregar venha até a doca.',
                            placeholder: 'Digite a mensagem',
                        }]}
                    buttons={['Cancel', {
                        text: 'Ok', handler: async (d) => {
                            if (!d.mensagem || d.mensagem.trim() == "") {
                                return null;
                            }

                            const indice = this.state.indice;
                            let items = [...this.state.ret.Items];
                            let anotacoes = items[indice].anotacoes;
                            items[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: 'Incluindo...' }]
                            this.setState((state: any) => ({ ...state, [state.ret.Items]: [...items], showAlertAnotacao: false }));

                            let result = await this.postChamada(items[indice].pk, d.mensagem);
                            if (result) {
                                //items[indice].anotacoes = [...items[indice].anotacoes, { data: new Date().toISOString(), anotacao: d.mensagem }];
                                setTimeout(() => {
                                    items[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: d.mensagem }];
                                    this.setState((state: any) => ({ ...state, [state.ret.Items]: [...items], showAlertAnotacao: false }));
                                }, 1000);
                            }
                            else {
                                items[indice].anotacoes = [...anotacoes, { data: new Date().toISOString(), anotacao: 'Erro na inserção...', cor: 'var(--ion-color-danger)' }];
                                this.setState((state: any) => ({ ...state, [state.ret.Items]: [...items], showAlertAnotacao: false }));
                                setTimeout(() => {
                                    items[indice].anotacoes = [...anotacoes];
                                    this.setState((state: any) => ({ ...state, [state.ret.Items]: [...items], showAlertAnotacao: false }));
                                }, 5000);
                            }
                        }
                    }]}
                />
                <IonAlert
                    isOpen={this.state.showAlertEncerramento}
                    onDidDismiss={() => this.setState((state: any) => ({ ...state, showAlertEncerramento: false }))}
                    cssClass="custom-alert-encerrar"
                    header={'Encerrar operação'}
                    //message={'Realizar <strong>encerramento</strong>?'}
                    backdropDismiss={false}
                    buttons={[{
                        text: 'Cancelar',
                        role: 'cancel',
                    }, {
                        text: 'Confirmar',
                        cssClass: 'custom-alert-encerrar-confirm',
                        handler: async (statusEncerramento) => {
                            if (!statusEncerramento) {
                                return null;
                            }

                            // buscar se o mercado tem no cadastro ativacao para controlar devolucoes por nota
                            if (this.props.clienteClassificaOperacao) {

                                // Se for devolvido, abre modal para preencher dados das notas
                                if (statusEncerramento === 'Devolvido') {
                                    const indice = this.state.indice;
                                    const notas = this.state.ret.Items[indice].notasAdicionais || [];
                                    const notasDevolucao: any = {};
                                    notas.forEach((nota: any) => {
                                        notasDevolucao[nota.notaFiscal] = {
                                            devolvida: false,
                                            motivo: '',
                                            valor: '',
                                            vencimento: ''
                                        };
                                    });
                                    this.setState((state: any) => ({
                                        ...state,
                                        showAlertEncerramento: false,
                                        showModalDevolucao: true,
                                        statusEncerramentoTemp: statusEncerramento,
                                        notasDevolucao: notasDevolucao
                                    }));
                                    return;
                                }
                            }

                            //console.log('encerrar opacao',d);
                            const indice = this.state.indice;
                            let items = [...this.state.ret.Items];
                            items[indice].divEncerrando = true;
                            this.setState((state: any) => ({ ...state, [state.ret.Items]: [...items], showAlertEncerramento: false }));

                            let result = await this.putEncerramento(items[indice].pk, statusEncerramento);
                            if (result) {
                                setTimeout(() => {
                                    items[indice].divEncerrado = true;
                                    this.setState((state: any) => ({ ...state, [state.ret.Items]: [...items], showAlertEncerramento: false }));
                                }, 1000);
                            } else {
                                items[indice].divEncerrando = false;
                                this.setState((state: any) => ({ ...state, [state.ret.Items]: [...items], showAlertEncerramento: false }));
                            }
                        }
                    }]}
                    inputs={[
                        {
                            label: 'Concluído',
                            type: 'radio',
                            value: 'Concluído',
                            checked: true
                        },
                        {
                            label: 'Devolvido',
                            type: 'radio',
                            value: 'Devolvido',
                        },
                        {
                            label: 'Desistência',
                            type: 'radio',
                            value: 'Desistência',
                        },
                    ]}
                />
                <IonModal
                    isOpen={this.state.showModalDevolucao}
                    onDidDismiss={() => this.setState((state: any) => ({ ...state, showModalDevolucao: false }))}
                    backdropDismiss={false}
                    placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
                >
                    <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonToolbar placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Informar dados de devolução</IonTitle>
                            <IonButton slot="end" fill="clear" onClick={() => this.setState((state: any) => ({ ...state, showModalDevolucao: false }))} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                Fechar
                            </IonButton>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonGrid style={{ fontSize: '12px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonRow style={{ fontWeight: 700, borderBottom: '1px solid #ddd', paddingBottom: '6px', fontSize: '11px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonCol size="8" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Nota</IonCol>
                                <IonCol size="4" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Devolvida</IonCol>
                            </IonRow>
                            {(this.state.ret.Items[this.state.indice]?.notasAdicionais || [])
                                .slice()
                                .sort((a: any, b: any) => this.getNumeroNota(a).localeCompare(this.getNumeroNota(b)))
                                .map((nota: any) => {
                                    const devolvida = this.state.notasDevolucao[nota.notaFiscal]?.devolvida || false;

                                    return (
                                        <React.Fragment key={`nota-${nota.notaFiscal}`}>
                                            <IonRow style={{ borderBottom: devolvida ? 'none' : '1px solid #eee', alignItems: 'center', fontSize: '12px', paddingTop: '6px', paddingBottom: '6px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                <IonCol size="8" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                    <IonText placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{this.getNumeroNota(nota)}</IonText>
                                                </IonCol>
                                                <IonCol size="4" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                    <IonCheckbox
                                                        checked={devolvida}
                                                        onIonChange={(e) => {
                                                            const notasDevolucao = { ...this.state.notasDevolucao };
                                                            notasDevolucao[nota.notaFiscal] = {
                                                                ...notasDevolucao[nota.notaFiscal],
                                                                notaFiscal: nota.notaFiscal,
                                                                numeroNotaFiscal: this.getNumeroNota(nota),
                                                                devolvida: e.detail.checked
                                                            };
                                                            this.setState({ notasDevolucao });
                                                            console.log('notasDevolucao', notasDevolucao);
                                                        }}
                                                        placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
                                                    />
                                                </IonCol>
                                            </IonRow>

                                            {devolvida && (
                                                <IonRow style={{ borderBottom: '1px solid #eee', paddingBottom: '8px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                    <IonCol size="12" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                        <IonGrid style={{ padding: 0 }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                            <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                                <IonCol size="12" sizeMd="4" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                                    <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                                        <IonLabel position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Motivo da devolução</IonLabel>
                                                                        <IonSelect
                                                                            interface="popover"
                                                                            value={this.state.notasDevolucao[nota.notaFiscal]?.motivo || ''}
                                                                            placeholder="Selecione"
                                                                            style={{ fontSize: '12px' }}
                                                                            onIonChange={(e) => {
                                                                                const notasDevolucao = { ...this.state.notasDevolucao };
                                                                                notasDevolucao[nota.notaFiscal] = {
                                                                                    ...notasDevolucao[nota.notaFiscal],
                                                                                    motivo: e.detail.value || ''
                                                                                };
                                                                                this.setState({ notasDevolucao });
                                                                            }}
                                                                            onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
                                                                        >
                                                                            {MOTIVOS_DEVOLUCAO.map((motivo) => (
                                                                                <IonSelectOption key={`motivo-${motivo}`} value={motivo} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{motivo}</IonSelectOption>
                                                                            ))}
                                                                        </IonSelect>
                                                                    </IonItem>
                                                                </IonCol>
                                                                <IonCol size="12" sizeMd="4" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                                    <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                                        <IonLabel position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Valor da nota</IonLabel>
                                                                        <IonInput
                                                                            type="number"
                                                                            value={this.state.notasDevolucao[nota.notaFiscal]?.valor || ''}
                                                                            placeholder="R$ 0,00"
                                                                            style={{ fontSize: '12px' }}
                                                                            onIonChange={(e) => {
                                                                                const notasDevolucao = { ...this.state.notasDevolucao };
                                                                                notasDevolucao[nota.notaFiscal] = {
                                                                                    ...notasDevolucao[nota.notaFiscal],
                                                                                    valor: e.detail.value || ''
                                                                                };
                                                                                this.setState({ notasDevolucao });
                                                                            }}
                                                                            onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
                                                                        />
                                                                    </IonItem>
                                                                </IonCol>
                                                                <IonCol size="12" sizeMd="4" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                                    <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                                        <IonLabel position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Vencimento</IonLabel>
                                                                        <IonInput
                                                                            type="date"
                                                                            value={this.state.notasDevolucao[nota.notaFiscal]?.vencimento || ''}
                                                                            style={{ fontSize: '12px' }}
                                                                            onIonChange={(e) => {
                                                                                const notasDevolucao = { ...this.state.notasDevolucao };
                                                                                notasDevolucao[nota.notaFiscal] = {
                                                                                    ...notasDevolucao[nota.notaFiscal],
                                                                                    vencimento: e.detail.value || ''
                                                                                };
                                                                                this.setState({ notasDevolucao });
                                                                            }}
                                                                            placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
                                                                        />
                                                                    </IonItem>
                                                                </IonCol>
                                                            </IonRow>
                                                        </IonGrid>
                                                    </IonCol>
                                                </IonRow>
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                        </IonGrid>
                        <IonCol size="12" style={{ marginTop: '20px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonButton expand="full" color="primary" onClick={() => this.finalizarDevolvucaoEEncerrar()} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                Finalizar e Encerrar Operação
                            </IonButton>
                        </IonCol>
                    </IonContent>
                </IonModal>
            </>);
    }

    loadItems(filtro: any, lojas: any, ordenar: boolean) {
        let token: string = "";
        const tkn = localStorage.getItem("token");
        if (typeof (tkn) === "string") {
            token = tkn;
        }

        fetch(urlBase.url + "/operacoes?filtro=" + filtro + "&lojas=" + lojas + "&ordenar=" + ordenar,
            {
                method: urlBase.method,
                headers: [
                    ["token", token]
                ],
                credentials: 'include'
            }).then((resp: Response) => {
                if (resp.status == 401) {
                    this.props.router.push("../login");
                }
                else {
                    resp.json().then((res: any) => {

                        let varDataInicio = '2025-01-01T17:35:28.074Z';

                        //const myNewArray = res.Items.map((item:any, index:any) =>  { return {"number" :index, ...item} } );
                        res.Items.map((item: any) => {
                            varDataInicio = item.dataInicio > varDataInicio ? item.dataInicio : varDataInicio;
                            let notasFiltro = JSON.stringify(item.notasAdicionais);
                            let liberado;
                            if (item.hasOwnProperty('liberado')) {
                                liberado = item.liberado;
                            }
                            else {
                                liberado = false;
                            }

                            // New properties to be added
                            const newPropsObj = {
                                notasFiltro: notasFiltro,
                                liberado: liberado
                            };

                            return Object.assign(item, newPropsObj);
                        })

                        window.localStorage.setItem("maiorDataOperacao", varDataInicio);
                        //console.log("maiorDataOperacao",varDataInicio);
                        this.setState({ loading: false, ret: res, filtro: filtro, lojas: lojas, lastEvaluatedKey: res.LastEvaluatedKey });
                    }).catch((e: any) => console.log(e));
                }
            }).catch((e: any) => { console.log(e); this.props.router.push("../login") });
    }

    loadMoreItems() {
        if (this.state.lastEvaluatedKey &&
            this.state.lastEvaluatedKey.hasOwnProperty("gsi2sk") &&
            this.state.lastEvaluatedKey.hasOwnProperty("pk") &&
            this.state.lastEvaluatedKey.hasOwnProperty("sk")) {

            let token: string = "";
            const tkn = localStorage.getItem("token");
            if (typeof (tkn) === "string") {
                token = tkn;
            }

            fetch(urlBase.url + "/operacoes?filtro=" + this.state.filtro + "&isk=" + this.state.lastEvaluatedKey.gsi2sk + "&pk=" + this.state.lastEvaluatedKey.pk + "&sk=" + this.state.lastEvaluatedKey.sk + "&lojas=" + this.state.lojas,
                {
                    method: urlBase.method,
                    headers: [
                        ["token", token]
                    ],
                    credentials: 'include'
                }).then((resp: Response) => {
                    resp.json().then((operacoes: any) => {

                        operacoes.Items.map((item: any) => {
                            let notasFiltro = JSON.stringify(item.notasAdicionais);
                            return { 'notasFiltro': notasFiltro, ...item }
                        });

                        this.setState((state: any) => ({ ret: { Items: [...state.ret.Items, ...operacoes.Items], LastEvaluatedKey: operacoes.LastEvaluatedKey || undefined }, lastEvaluatedKey: operacoes.LastEvaluatedKey }));
                    })
                })
                .catch(err => console.error(err));
        }
    }

    componentDidMount() {
        this.loadItems(this.props.filtro, this.props.lojas, this.props.ordenar);
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
        if (prevProps.filtro != this.props.filtro || prevProps.lojas != this.props.lojas || prevProps.reload != this.props.reload || prevProps.ordenar != this.props.ordenar) {
            this.setState({ loading: true });
            this.loadItems(this.props.filtro, this.props.lojas, this.props.ordenar);
        }
    }

    async updateLiberacaoService(pk: string, liberado: boolean) {
        let result = false;
        let objeto = { "liberado": liberado };

        await fetch(operacaoLiberarOperacao.url.replace('{pk}', pk).replace(/#/g, '%23'),
            {
                method: operacaoLiberarOperacao.method,
                headers: [
                    ["token", localStorage.getItem("token") || ""]
                ],
                body: JSON.stringify(objeto),
                credentials: 'include'
            }).then((resp: Response) => {
                if (resp.status == 200) result = true;
            });
        return result;
    }

    async updateStatusOperacaoService(pk: string, statusOperacao: string) {
        let result = false;
        let objeto = { "statusOperacao": statusOperacao };

        await fetch(operacaoAlterarStatusOperacao.url.replace('{pk}', pk).replace(/#/g, '%23'),
            {
                method: operacaoAlterarStatusOperacao.method,
                headers: [
                    ["token", localStorage.getItem("token") || ""]
                ],
                body: JSON.stringify(objeto),
                credentials: 'include'
            }).then((resp: Response) => {
                if (resp.status == 200) result = true;
            });
        return result;
    }

    async updateStatusEncerramentoService(pk: string, statusEncerramento: string) {
        let result = false;
        let objeto = { "statusEncerramento": statusEncerramento };

        await fetch(operacaoAlterarStatusEncerramento.url.replace('{pk}', pk).replace(/#/g, '%23'),
            {
                method: operacaoAlterarStatusEncerramento.method,
                headers: [
                    ["token", localStorage.getItem("token") || ""]
                ],
                body: JSON.stringify(objeto),
                credentials: 'include'
            }).then((resp: Response) => {
                if (resp.status == 200) result = true;
            });
        return result;
    }

    async updateTipoCargaService(pk: string, tipoCarga: string) {
        let result = false;
        let objeto = { "tipoCarga": tipoCarga };

        await fetch(operacaoAlterarTipoCarga.url.replace('{pk}', pk).replace(/#/g, '%23'),
            {
                method: operacaoAlterarTipoCarga.method,
                headers: [
                    ["token", localStorage.getItem("token") || ""]
                ],
                body: JSON.stringify(objeto),
                credentials: 'include'
            }).then((resp: Response) => {
                if (resp.status == 200) result = true;
            });
        return result;
    }

    async updateSemaforo(pk: any, semaforo: number) {
        let result = false;
        let objeto = { semaforo: semaforo };

        await fetch(operacaoAtualizarSemaforo.url.replace("{pk}", pk.replace(/#/g, '%23')),
            {
                method: operacaoAtualizarSemaforo.method,
                headers: [
                    ["token", localStorage.getItem("token") || ""]
                ],
                body: JSON.stringify(objeto),
                credentials: 'include'
            }).then((resp: Response) => {
                if (resp.status == 200) result = true;
            });
        return result;
    }

    async postAnotacao(pk: any, mensagem: any) {
        let result = false;
        let objeto = { mensagem: mensagem }

        await fetch(operacaoRegistrarAnotacao.url.replace("{pk}", pk.replace(/#/g, '%23')),
            {
                method: operacaoRegistrarAnotacao.method,
                headers: [
                    ["token", localStorage.getItem("token") || ""]
                ],
                body: JSON.stringify(objeto),
                credentials: 'include'
            }).then((resp: Response) => {
                if (resp.status == 200) result = true;
            });
        return result;
    }

    async postChamada(pk: any, mensagem: any) {
        let result = false;
        let objeto = { mensagem: mensagem }

        await fetch(operacaoChamarMotorista.url.replace("{pk}", pk.replace(/#/g, '%23')),
            {
                method: operacaoChamarMotorista.method,
                headers: [
                    ["token", localStorage.getItem("token") || ""]
                ],
                body: JSON.stringify(objeto),
                credentials: 'include'
            }).then((resp: Response) => {
                if (resp.status == 200) result = true;
            });
        return result;
    }

    async putEncerramento(pk: any, statusEncerramento: any, notasDevolvidas?: any) {
        let result = false;

        let requestBody = {
            "statusEncerramento": statusEncerramento,
            "notasDevolvidas": notasDevolvidas || []
        };

        await fetch(encerrarOperacao.url.replace("{id}", pk.replace(/#/g, '%23')),
            {
                method: encerrarOperacao.method,
                headers: [
                    ["token", localStorage.getItem("token") || ""]
                ],
                body: JSON.stringify(requestBody),
                credentials: 'include'
            }).then((resp: Response) => {
                if (resp.status == 200) result = true;
            });
        return result;
    }
}

class OperacoesCards extends React.Component<any, any> {
    render() {

        const Header = () => {
            return (
                <div
                    style={{
                        height: '40px',
                    }}
                >
                </div>
            )
        }

        const Footer = () => {
            return (
                <div
                    style={{
                        //height: '400px',
                        padding: '3rem',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    {(this.props.items.LastEvaluatedKey) ?
                        <IonButton onClick={this.props.loadMoreItems} color='tertiary' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Carregar mais itens</IonButton>
                        : <></>}
                </div>
            )
        }

        return (
            <>
                {
                    this.props.items.Items.length > 0 ?
                        <Virtuoso className="ion-content-scroll-host"
                            style={{ height: '100%' }}
                            //overscan={1440}
                            overscan={{ main: 1440, reverse: 720 }}
                            data={this.props.items.Items}
                            /*endReached={this.props.loadMoreItems}*/
                            //itemSize={() => 280}
                            itemContent={(index: any, value: any) => (

                                //(value.dataInicio.substring(0,10) != this.props.items.Items[index-1].dataInicio.substring(0,10)?<div>cabeçalho</div>:<></>) &&
                                ((value.status == "Concluido") ||
                                    (
                                        ((this.props.chipStatusOperacaoFilter.preLiberado && value.statusOperacao == 'Pré-liberado') || (this.props.chipStatusOperacaoFilter.liberado && value.statusOperacao == 'Liberado') || (this.props.chipStatusOperacaoFilter.tratativa && value.statusOperacao == 'Tratativa') || (this.props.chipStatusOperacaoFilter.emLiberacao && value.statusOperacao == 'Em liberação') || (this.props.chipStatusOperacaoFilter.emConferencia && value.statusOperacao == 'Em conferência') || (this.props.chipStatusOperacaoFilter.iniciado && value.statusOperacao == 'Iniciado') || (!value.hasOwnProperty('statusOperacao') && this.props.chipStatusOperacaoFilter.iniciado) || (this.props.chipStatusOperacaoFilter.validacaoConferencia && value.statusOperacao == 'Fechamento nota') || (this.props.chipStatusOperacaoFilter.liberacaoCanhoto && value.statusOperacao == 'Liberação canhoto'))
                                        && ((this.props.chipCargaFilter.seca && value.tipoCarga == 'Seca') || (this.props.chipCargaFilter.perecivel && value.tipoCarga == 'Perecível'))
                                        && ((this.props.chipTipoOperacaoFilter.carregamento && value.tipoOperacao == 'Carregamento') || (this.props.chipTipoOperacaoFilter.entrega && value.tipoOperacao == 'Entrega') || (this.props.chipTipoOperacaoFilter.coleta && value.tipoOperacao == 'Coleta'))
                                    )
                                ) && (value.status !== 'Concluido' || (this.props.chipValidacaoFilter.validada && !!value.dataValidacao) || (this.props.chipValidacaoFilter.naoValidada && !value.dataValidacao)) ?
                                    //(true == true) ?
                                    <>
                                        {
                                            value.status == "Concluido" ?
                                                index == 0 ?
                                                    <OperacoesCardDateGroup date={value.dataEncerramento}></OperacoesCardDateGroup> :
                                                    value.dataEncerramento.substring(0, 10) != this.props.items.Items[(index - 1 < 0) ? 0 : index - 1].dataEncerramento.substring(0, 10) ?
                                                        <OperacoesCardDateGroup date={value.dataEncerramento}></OperacoesCardDateGroup> :
                                                        <></> : <></>
                                        }
                                        {value.status == "Em andamento" ?
                                            this.props.pesquisa == "" ?
                                                < OperacoesCard lojasCores={this.props.lojasCores} item={value} indice={index} changeSemaforo={this.props.changeSemaforo} router={this.props.router} usaLiberacao={this.props.usaLiberacao} changeLiberacao={this.props.changeLiberacao} registrarAnotacao={this.props.registrarAnotacao} registrarChamada={this.props.registrarChamada} registrarEncerramento={this.props.registrarEncerramento} changeStatusOperacao={this.props.changeStatusOperacao} changeStatusEncerramento={this.props.changeStatusEncerramento} changeTipoCarga={this.props.changeTipoCarga} clienteUtilizaLeituraCega={this.props.clienteUtilizaLeituraCega} />
                                                :
                                                value.notasFiltro?.indexOf(this.props.pesquisa) > -1 ?
                                                    <>< OperacoesCard lojasCores={this.props.lojasCores} item={value} indice={index} changeSemaforo={this.props.changeSemaforo} router={this.props.router} usaLiberacao={this.props.usaLiberacao} changeLiberacao={this.props.changeLiberacao} registrarAnotacao={this.props.registrarAnotacao} registrarChamada={this.props.registrarChamada} registrarEncerramento={this.props.registrarEncerramento} changeStatusOperacao={this.props.changeStatusOperacao} changeStatusEncerramento={this.props.changeStatusEncerramento} changeTipoCarga={this.props.changeTipoCarga} clienteUtilizaLeituraCega={this.props.clienteUtilizaLeituraCega} /> </> :
                                                    <></>
                                            :
                                            < OperacoesCard lojasCores={this.props.lojasCores} item={value} indice={index} changeSemaforo={this.props.changeSemaforo} router={this.props.router} usaLiberacao={this.props.usaLiberacao} changeLiberacao={this.props.changeLiberacao} registrarAnotacao={this.props.registrarAnotacao} registrarChamada={this.props.registrarChamada} registrarEncerramento={this.props.registrarEncerramento} changeStatusOperacao={this.props.changeStatusOperacao} changeStatusEncerramento={this.props.changeStatusEncerramento} changeTipoCarga={this.props.changeTipoCarga} clienteUtilizaLeituraCega={this.props.clienteUtilizaLeituraCega} />
                                        }
                                        { }
                                    </> : <><p style={{ fontSize: '1px' }}>&nbsp;</p>{/*bug precisa aparecer pelo menos na tela um pedacinho para o componente renderizar, se não dá erro no filtro de situaão da liberação*/}</>
                            )}
                            components={{ Header, Footer }}
                        /> :
                        <div style={{ width: '100%', textAlign: 'center' }}><br></br>Sem operações no momento</div>
                }
            </>
        )

    }
}

class OperacoesCardDateGroup extends React.Component<any, any> {
    render() {
        return (
            <IonItem lines='none' style={{ marginTop: '20px', marginBottom: '10px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <div className={"cabecalho"} style={{ marginLeft: '10px' }} >{new Date(this.props.date).toLocaleString('pt-BR').substring(0, 10)}</div>
            </IonItem>
        )
    }
}
class OperacoesCard extends React.Component<any, any> {
    render() {

        return (
            !this.props.item.divEncerrado ?
                <div>
                    <IonItem lines='none' style={{ height: '36px', minHeight: '36px', padding: '0', margin: '0' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <div style={{ height: '30px', minHeight: '30px', display: 'flex', width: '100%', border: '1px hidden #dddddd', borderBottom: '0px', borderRadius: '10px 10px 0px 0px', padding: '0', margin: '1' }}>
                            <div style={{ borderRadius: '10px 10px 0px 0px', marginLeft: '1px', backgroundColor: Object.hasOwn(this.props.lojasCores || {}, this.props.item.gsi2pk) ? this.props.lojasCores[this.props.item.gsi2pk] : 'var(--ion-color-primary)' }}>
                                <IonLabel slot='start' style={{ maxWidth: '150px', fontSize: "14px", fontWeight: 'bold', padding: '0', margin: '5px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{this.props.item.clienteNomeInterno ? this.props.item.clienteNomeInterno : this.props.item.clienteNome ? this.props.item.clienteNome : ""}</IonLabel>
                            </div>
                            <div style={{ width: '100%', textAlign: 'center' }}></div>
                            <div style={{ borderRadius: '10px 10px 0px 0px', marginRight: '1px', backgroundColor: 'var(--ion-color-tertiary)' }}>
                                <IonLabel slot='end' style={{ minWidth: '120px', fontSize: "15px", fontWeight: 'bold', textAlign: 'center', padding: '0', margin: '5px', color: 'white' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><span style={{ fontSize: '12px' }}>duração: </span>{tempoCorrido(new Date(this.props.item.dataInicio), (this.props.item.dataEncerramento ? new Date(this.props.item.dataEncerramento) : new Date()))}</IonLabel>
                            </div>
                        </div>
                    </IonItem>
                    <IonItem lines='none' style={{ paddingTop: '0px', paddingBottom: '10px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <div style={{ width: '100%', marginBottom: '5px', border: '1px solid #dddddd', borderTop: '0px', borderRadius: '0px 0px 10px 10px', boxShadow: '0px 1px gray', position: 'relative' }}>
                            <OperacoesCardHeader item={this.props.item} indice={this.props.indice} changeSemaforo={this.props.changeSemaforo} router={this.props.router} usaLiberacao={this.props.usaLiberacao} changeLiberacao={this.props.changeLiberacao} changeStatusOperacao={this.props.changeStatusOperacao} changeStatusEncerramento={this.props.changeStatusEncerramento} changeTipoCarga={this.props.changeTipoCarga} clienteUtilizaLeituraCega={this.props.clienteUtilizaLeituraCega} />

                            <OperacoesCardDetail item={this.props.item} />

                            {(this.props.item.status == "Em andamento") ?
                                (<OperacoesCardFooter item={this.props.item} indice={this.props.indice} registrarAnotacao={this.props.registrarAnotacao} registrarChamada={this.props.registrarChamada} registrarEncerramento={this.props.registrarEncerramento} router={this.props.router} />) : (<></>)}

                            {(this.props.item.divEncerrando ?
                                <div style={{ position: 'absolute', left: '0px', top: '0px', background: 'gray', height: '100%', width: '100%', zIndex: 999, borderRadius: '0px 0px 10px 10px', opacity: 0.8, paddingRight: '45px' }}>
                                    <span style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', color: 'white', fontSize: '30px', fontWeight: 'bold' }}>Encerrando...</span>
                                </div> : <></>)}
                        </div>
                    </IonItem>
                </div> :
                <></>
        )
    }
}

function tempoCorrido(horario: Date, horarioFim: Date) {
    var g = Math.ceil((horarioFim.getTime() - horario.getTime()) / 1000 / 60);
    if (g > 1440) {
        return Math.floor(g / 60).toString() + 'h';
    }
    else if (g > 60) {
        return Math.floor(g / 60).toString() + 'h' + ('0' + (g % 60).toString()).substr(-2) + '';
    }
    else {
        return g.toString() + 'min';
    }
}

class OperacoesCardHeader extends React.Component<any, any> {
    render() {
        const value = this.props.item;
        // cor antiga de acordo com o semaforo
        //const cor = this.props.item.status != "Em andamento" ? 'primary' : this.props.item.semaforo == 2 ? 'secondary' : this.props.item.semaforo == 3 ? 'tertiary' : 'primary';

        // variavel para identificar se o cliente é o cliente que utiliza leitura cega, para exibir opcoes de 
        // status especificos para quem usa leitura cega, como "Pré-liberado" e "Fechamento nota"
        const utilizaLeituraCega = this.props.clienteUtilizaLeituraCega;

        // cor nova de acordo com o status da operacao
        const cor = this.props.item.status === "Concluido" ? 'primary' : this.props.item.statusOperacao === "Liberado" ? 'success' : this.props.item.statusOperacao === 'Tratativa' ? 'danger' : this.props.item.statusOperacao === 'Em liberação' ? 'liberacao' : this.props.item.statusOperacao === 'Em conferência' ? 'purple' : this.props.item.statusOperacao === 'Pré-liberado' ? 'blue' : this.props.item.statusOperacao === 'Fechamento nota' ? 'marrom' : this.props.item.statusOperacao === 'Liberação canhoto' ? 'lightpink' : 'gray';
        const indice = this.props.indice;

        return (
            <>
                <IonItem color={cor} style={{ width: "100%", borderRadius: "0px 0px 0 0", background: '#eeeeee' }} lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
                    <IonLabel slot="start" style={{ display: 'flex', alignItems: 'center', margin: 0 }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{value.operacaoTipoOperacao.concat(" - ", value.tipoCarga, " ")}
                        {(this.props.item.status == "Em andamento") ?
                            (value.atualizandoTipoCarga) ?
                                <IonButton style={{ '--background': 'gray', '--color': '#ffffff', margin: '0px', marginLeft: '8px', padding: '0px', '--padding-start': '0px', '--padding-end': '0px', height: 'fit-content' }} slot="icon-only" size="small" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonIcon style={{ padding: '2px' }} icon={sync} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon></IonButton>
                                :
                                <IonButton onClick={() => { this.props.changeTipoCarga(indice, value.tipoCarga == "Seca" ? "Perecível" : "Seca") }} color="light" style={{ margin: '0px', marginLeft: '8px', padding: 0, '--padding-start': '0px', '--padding-end': '0px', height: 'fit-content' }} slot="icon-only" size="small" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonIcon style={{ padding: '2px' }} icon={repeatOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon></IonButton>
                            : <></>}
                    </IonLabel>

                    {(this.props.item.status == "Em andamento" && this.props.usaLiberacao == true) ?
                        <IonIcon icon={pulseOutline} slot='start' style={{ marginRight: '5px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon> :
                        <IonIcon icon={flag} slot='start' style={{ marginRight: '5px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                    }

                    {(this.props.item.status == "Em andamento" && this.props.usaLiberacao == true) ?
                        (value.atualizandoStatusOperacao) ?
                            <IonChip slot='start' style={{ '--background': 'gray', '--color': '#ffffff' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonIcon icon={sync} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} ></IonIcon>
                                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>alterando</IonLabel>
                            </IonChip> :
                            <IonSelect style={{ borderRadius: '30px', height: '30px', background: value.statusOperacao == 'Liberado' ? 'green' : value.statusOperacao == 'Tratativa' ? 'red' : value.statusOperacao == 'Em liberação' ? 'yellow' : value.statusOperacao == 'Em conferência' ? '#600099' : value.statusOperacao == 'Pré-liberado' ? '#00008B' : value.statusOperacao == 'Fechamento nota' ? '#8B4513' : value.statusOperacao == 'Liberação canhoto' ? '#FF00CC' : value.statusOperacao == '' ? '#00008B' : 'gray', color: value.statusOperacao == 'Em liberação' ? 'black' : 'white', textAlign: 'center' }} value={value.statusOperacao ? value.statusOperacao : 'Iniciado'} slot='start' interface="popover" placeholder="Select One" onIonChange={(e) => this.props.changeStatusOperacao(indice, e.detail.value)} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
                                <IonSelectOption value="Iniciado" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Iniciado</IonSelectOption>
                                <IonSelectOption value="Em liberação" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Em liberação</IonSelectOption>
                                <IonSelectOption value="Pré-liberado" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Pré-liberado</IonSelectOption>
                                <IonSelectOption value="Tratativa" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Tratativa</IonSelectOption>
                                <IonSelectOption value="Liberado" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Liberado</IonSelectOption>
                                <IonSelectOption value="Em conferência" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Em conferência</IonSelectOption>
                                {
                                    utilizaLeituraCega ?
                                        <>
                                            <IonSelectOption value="Fechamento nota" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Fechamento nota</IonSelectOption>
                                            <IonSelectOption value="Liberação canhoto" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Liberação canhoto</IonSelectOption>
                                        </> : null
                                }
                            </IonSelect>
                        : (value.atualizandoStatusEncerramento) ?
                            <IonChip slot='start' style={{ '--background': 'gray', '--color': '#ffffff' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonIcon icon={sync} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} ></IonIcon>
                                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>alterando</IonLabel>
                            </IonChip> :
                            <IonSelect style={{ borderRadius: '30px', height: '30px', border: '1px solid #333333', textAlign: 'center' }} value={value.statusEncerramento ? value.statusEncerramento : 'Não classificado'} slot='start' interface="popover" placeholder="Não classificado" onIonChange={(e) => this.props.changeStatusEncerramento(indice, e.detail.value)} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
                                <IonSelectOption value="Concluído" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Concluído</IonSelectOption>
                                <IonSelectOption value="Devolvido" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Devolvido</IonSelectOption>
                                <IonSelectOption value="Desistência" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Desistência</IonSelectOption>
                            </IonSelect>
                    }

                    {(this.props.item.status == "Em andamento" && value.sk.startsWith("usuarios")) ? (
                        <IonLabel slot='end' title='Aberto manualmente' style={{
                            padding: '0px', height: '40px', margin: '0px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: '10px',
                            marginRight: '20px',
                            fontSize: 'x-large'
                        }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonIcon slot='end' icon={handRight} style={{ pointerEvents: 'none' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} ></IonIcon>
                        </IonLabel>
                    ) : ('')}

                    {(this.props.item.status == "Concluido") ?
                        (
                            <>
                                <IonButton hidden={this.props.item?.dataValidacao ? false : true} slot='end' fill='clear' style={{ marginInlineStart: '10px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                    <IonIcon slot="icon-only" color='tertiary' icon={checkmarkCircle} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                                </IonButton>
                                <IonButton hidden={true} slot='end' fill='clear' style={{ marginInlineStart: '10px' }} onClick={() => { this.props.router.push("operacoes/acompanhar", { estabelecimento: "A", codigoBarras: "B", operacaoid: value.id.replace(/#/g, '%23') }); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                    <IonIcon slot="icon-only" color='warning' icon={bookmarkOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                                </IonButton>
                            </>) :
                        <></>}

                    <IonButton slot='end' fill='clear' style={{ marginInlineStart: '10px' }} onClick={() => { this.props.router.push("operacoes/acompanhar", { estabelecimento: "A", codigoBarras: "B", operacaoid: value.id.replace(/#/g, '%23') }); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonIcon slot="icon-only" color='light' icon={documentText} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                    </IonButton>
                </IonItem>
            </>
        )

    }
}

class OperacoesCardSemaforo extends React.Component<any, any> {
    render() {
        const changeSemaforo = this.props.changeSemaforo;
        const indice = this.props.indice;
        const atualizandoSemaforo = this.props.atualizandoSemaforo;

        return (!atualizandoSemaforo ?
            <IonLabel slot='end' style={{
                background: '#fff', padding: '0px', height: '40px', margin: '0px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '10px',
                width: '100px'
            }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonIcon slot='end' style={{ fontSize: "24px" }} color='primary' icon={ellipse} onClick={() => { changeSemaforo(indice, 1); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                <IonIcon slot='end' style={{ fontSize: "24px" }} color='secondary' icon={ellipse} onClick={() => { changeSemaforo(indice, 2); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                <IonIcon slot='end' style={{ fontSize: "24px" }} color='tertiary' icon={ellipse} onClick={() => { changeSemaforo(indice, 3); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
            </IonLabel>
            :
            <div slot='end' style={{
                background: 'gray', padding: '0px', height: '40px', margin: '0px',
                color: '#ffffff',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '10px',
                width: '100px'
            }}><IonIcon icon={sync} style={{ marginLeft: '5px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon><IonLabel style={{ marginLeft: '5px', marginRight: '5px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>alterando</IonLabel>

            </div>);
    }
}

class OperacoesCardDetail extends React.Component<any, any> {

    cpfMask(v: string) {
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
        return v;
    }

    render() {
        const value = this.props.item;

        return (
            <IonGrid style={{ background: '#ffffff', margin: '0px', padding: '0px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonRow style={{ background: '#eeeeee' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCol style={{ textAlign: 'center', '--min-height': 'auto' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonItem lines='none' style={{ '--min-height': 'auto' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
                            <IonIcon slot='start' src={person} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} ></IonIcon>
                            <IonNote slot='start' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >motorista</IonNote>
                            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >{value.motoristaNome}</IonLabel>
                        </IonItem>
                    </IonCol>
                    <IonCol style={{ textAlign: 'center', '--min-height': 'auto' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonItem lines='none' style={{ '--min-height': 'auto' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
                            <IonIcon slot='start' src={card} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} ></IonIcon>
                            <IonNote slot='start' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>cpf</IonNote>
                            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >{value.motoristaDocumento}</IonLabel>
                        </IonItem>
                    </IonCol>
                    <IonCol style={{ textAlign: 'center', '--min-height': 'auto' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonItem lines='none' style={{ '--min-height': 'auto' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
                            <IonIcon slot='start' src={car} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} ></IonIcon>
                            <IonNote slot='start' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>veículo</IonNote>
                            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >{value.veiculo.toUpperCase()}</IonLabel>
                        </IonItem>
                    </IonCol>
                </IonRow>
                <IonRow style={{ justifyContent: 'left' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
                        <IonItem style={{ width: "100%" }} lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonLabel style={{ margin: 0 }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
                                <IonText color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><h3>Notas Fiscais</h3></IonText>
                                {value.notasAdicionais.map((notasValue: any, index: any) => (value.notasFiltro += notasValue.notaFiscal.substr(25, 9).toString(),
                                    <p style={{ color: "#000000", display: 'flex' }}><span style={{ display: 'flex', marginBottom: 'auto', marginTop: 'auto', paddingRight: '3px' }} title={notasValue.liberada ? "Liberada automaticamente" : ""}><IonIcon style={{ alignSelf: 'center', pointerEvents: 'none' }} color={notasValue.liberada ? "success" : "light"} icon={checkbox} title='teste' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon></span><b>{notasValue.notaFiscal ? notasValue.notaFiscal.substr(25, 9) : "Não informada"}</b> | <IonNote style={{ fontSize: '11px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{notasValue.razaoSocial || "Não identificado"} | {notasValue.notaFiscal ? notasValue.notaFiscal.substr(6, 14).replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : ""}</IonNote><IonBadge style={{ fontSize: '11px', marginLeft: '5px', padding: '3px', alignSelf: 'center' }} hidden={notasValue.anotacao ? false : true} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{notasValue.anotacao || ""}</IonBadge></p>
                                ))}
                            </IonLabel>
                        </IonItem>
                    </IonCol>
                    {/*
                    <IonCol size='auto'>
                        <IonItem style={{ width: "100%" }} lines="none">
                            <IonLabel style={{ margin: 0 }} className="ion-text-wrap">
                                <IonText color="primary"><h3>Motorista</h3></IonText>
                                <p style={{ color: "#000000", fontWeight: "bold" }}>{value.motoristaNome}</p>
                                <p style={{ color: "#000000", fontWeight: "bold" }}>{this.cpfMask(value.motoristaDocumento)}</p>
                                <p style={{ color: "#000000", fontWeight: "bold" }}>Placa: {value.veiculo}</p>
                            </IonLabel>
                        </IonItem>
                    </IonCol>
                                */}
                    <IonCol style={{ minWidth: '330px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonItem style={{ width: "100%", '--min-height': 'auto' }} lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonLabel style={{ margin: 0 }} className="ion-text-wrap" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonText color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><h3>Anotações</h3></IonText>
                            </IonLabel>
                        </IonItem>

                        {
                            value.anotacoes?.filter((anotacao: any) => !anotacao.tipo || anotacao.tipo != "Status").sort(function (a: any, b: any) {
                                if (a.data < b.data) {
                                    return 1;
                                }
                                if (a.data > b.data) {
                                    return -1;
                                }
                                // a must be equal to b
                                return 0;
                            }).slice(0, 5).map((anotacoesValue: any) => (
                                <div style={{ marginBottom: '4px', width: '100%', borderRadius: '10px' }}>

                                    <IonItem lines='none' style={{ '--min-height': 'auto', width: '100%' }} color='#green' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                        <IonNote placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{new Date(anotacoesValue.data).toLocaleTimeString().substring(0, 5)}&nbsp;</IonNote>
                                        <IonLabel color='black' class="ion-text-wrap" style={{ margin: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: 'Open Sans, sans-serif', lineHeight: '16px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{anotacoesValue.anotacao}{/*<span style={{ fontSize: '10px', color: '#666', fontWeight: 'lighter' }}>{" (" + (anotacoesValue.pessoa || "") + ")"}</span>*/}</IonLabel>
                                    </IonItem>
                                    {/*
                                    <IonItem lines='none' style={{ '--min-height': 'auto', width: '100%' }}>
                                        <IonLabel color='black' style={{ margin: '0px', fontSize: '11px', fontFamily: 'Open Sans, sans-serif', lineHeight: '14px' }}>{new Date(anotacoesValue.data).toLocaleString()}</IonLabel>
                                    </IonItem>
                                    */}
                                </div>))
                        }

                    </IonCol>
                    {/* coluna para exibir as anotacoes de alteracao de status da operacao */}
                    <IonCol style={{ minWidth: '330px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonItem style={{ width: "100%", '--min-height': 'auto' }} lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonLabel style={{ margin: 0 }} className="ion-text-wrap" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonText color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><h3>Status</h3></IonText>
                            </IonLabel>
                        </IonItem>

                        {
                            value.anotacoes?.filter((anotacao: any) => anotacao.tipo && anotacao.tipo == "Status").sort(function (a: any, b: any) {
                                if (a.data < b.data) {
                                    return 1;
                                }
                                if (a.data > b.data) {
                                    return -1;
                                }
                                // a must be equal to b
                                return 0;
                            }).slice(0, 5).map((anotacoesValue: any) => (
                                <div style={{ marginBottom: '4px', width: '100%', borderRadius: '10px' }}>

                                    <IonItem lines='none' style={{ '--min-height': 'auto', width: '100%' }} color='#green' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                        <IonNote placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{new Date(anotacoesValue.data).toLocaleTimeString().substring(0, 5)}&nbsp;</IonNote>
                                        <IonLabel color='black' class="ion-text-wrap" style={{ margin: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: 'Open Sans, sans-serif', lineHeight: '16px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{anotacoesValue.anotacao}{/*<span style={{ fontSize: '10px', color: '#666', fontWeight: 'lighter' }}>{" (" + (anotacoesValue.pessoa || "") + ")"}</span>*/}</IonLabel>
                                    </IonItem>
                                    {/*
                                    <IonItem lines='none' style={{ '--min-height': 'auto', width: '100%' }}>
                                        <IonLabel color='black' style={{ margin: '0px', fontSize: '11px', fontFamily: 'Open Sans, sans-serif', lineHeight: '14px' }}>{new Date(anotacoesValue.data).toLocaleString()}</IonLabel>
                                    </IonItem>
                                    */}
                                </div>))
                        }

                    </IonCol>
                </IonRow>
            </IonGrid>
        )
    }
}

class OperacoesCardFooter extends React.Component<any, any> {
    render() {
        const value = this.props.item;

        return (
            <IonItem style={{ padding: 0, margin: 0, "borderRadius": "0px 0px 10px 10px", backgroundColor: "#eeeeee" }} color="grey" lines='none' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonSegmentButton style={{ height: "25px", padding: 0, margin: 0 }} color='tertiary' onClick={(e) => {
                    this.props.registrarChamada(this.props.indice);
                }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonIcon icon={megaphone} style={{ padding: 0, margin: 0 }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                    <IonLabel style={{ "fontSize": "11px", padding: 0, margin: 0 }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Chamar</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton style={{ height: "25px", padding: 0, margin: 0 }} color='tertiary' onClick={(e) => {
                    this.props.registrarAnotacao(this.props.indice);
                }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonIcon icon={pencil} style={{ padding: 0, margin: 0 }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                    <IonLabel style={{ "fontSize": "11px", padding: 0, margin: 0 }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Anotação</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton style={{ height: "25px", padding: 0, margin: 0 }} color='tertiary' onClick={(e) => { this.props.router.push("operacoes/acompanhar", { estabelecimento: "A", codigoBarras: "B", operacaoid: value.id.replace(/#/g, '%23') }); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonIcon icon={documentText} style={{ padding: 0, margin: 0 }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                    <IonLabel style={{ "fontSize": "11px", padding: 0, margin: 0 }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Detalhes</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton slot='end' style={{ height: "25px", padding: 0, margin: 0 }} color='primary' onClick={(e) => {
                    { this.props.registrarEncerramento(this.props.indice); }
                }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonIcon icon={power} color={"danger"} style={{ padding: 0, margin: 0 }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                    <IonLabel style={{ "fontSize": "11px", padding: 0, margin: 0 }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Encerrar</IonLabel>
                </IonSegmentButton>

            </IonItem>)
    }
}

export default OperacoesList;